/* eslint-disable */
export class GridColumnsSettings {
  constructor(rows, gridOptions, model) {
    this.rows = rows
    this.gridOptions = gridOptions
    this.model = model
  }

  processingCellStyle(columns) {
    if (columns) {
      this.setColumnsCellStyle(columns)
    }

    return columns
  }

  /** Получить колонки с установленой высотой из кэша, если он есть
   * @param {Array} currentColumns - текущие колонки
   * @param {String} keyForColumnState - ключ, чтобы достать закешированные колонки c localStorage
   * @returns - возвращает колонки текущие колонки или колонки объеденённые с данными с localStorage
   */
  getColumnsWithWidthFromCache(currentColumns, keyForColumnState) {
    let columnsFromCache = JSON.parse(localStorage.getItem(keyForColumnState))
    if (!columnsFromCache) {
      return currentColumns
    }

    let result = currentColumns.map((x) => {
      if (columnsFromCache[x.field]) {
        x.width = columnsFromCache[x.field]
      }
      return x
    })
    return result
  }

  // Установка стилей колонки
  setColumnsCellStyle(columns) {
    columns.forEach((col) => {
      if (col.cellStyle && typeof col.cellStyle == 'string') {
        col.cellStyle = this.getStyleFunction(col.cellStyle).bind(this)
      }
    })
  }

  // Получение стилей колонок
  getStyleFunction(scriptGetter) {
    return (params) => {
      let script = scriptGetter
      if (typeof scriptGetter == 'function') {
        ;[(script = scriptGetter())]
      }
      let func = `try{${script}}catch(e){console.warn(e)}`
      try {
        let resultFunction = new Function('params', func)({ ...params, rows: this.rows })
        let result = {...resultFunction,}
        if (params?.colDef?.rowTextWrapping) {
          result['white-space'] = 'normal'
        }
        return result
      } catch (e) {
        console.warn(e, func)
        return {}
      }
    }
  }

  /** Установка поведения обтекания текста у колонок и строки
   * @param {Array} column текущие колонки
   */
  setTextWrapping(column) {
    if (column?.columnTextWrapping) {
      column.headerComponentParams = {
        template:
          '<div class="ag-cell-label-container" role="presentation">' +
          '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
          '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
          '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
          '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
          '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
          '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
          '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
          '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
          '  </div>' +
          '</div>'
      }
    }

    if (!column?.rowTextWrapping) {
      return
    }

    // Установка поведения textWrapping для строк
    column.autoHeight = true
    column.wrapText = true
  }

  // Задать колонки возможность редактировать строки
  setEditableColumn(column) {
    if (!column?.editable) {
      return
    }
    // Перечень компонентов эдитора, в зависимости от выбранного типа
    const componentByRowEditorType = {
      textarea: 'agLargeTextCellEditor', // textarea ag-grid, она может менять размер строки.
      numeric: 'NumericCellRenderer',
      CheckboxCellRenderer: 'CheckboxCellRenderer'
    }

    column.cellEditor = componentByRowEditorType[column.cellRenderer]
  }

  columnHeightGetter() {
    // Получение высоты у самой высокой  колонки таблицы
    let columnHeaderTexts = [...document.querySelectorAll(`[id='${this.model.$ID}'] .ag-header-cell-text`)]
    let clientHeights = columnHeaderTexts.map((headerText) => headerText.clientHeight)
    let tallestHeaderTextHeight = Math.max(...clientHeights)

    return tallestHeaderTextHeight
  }

  columnHeightSetter() {
    // установить высоту для колонки
    let padding = 40
    let height = this.columnHeightGetter() + padding
    this.gridOptions.api.setHeaderHeight(height)
  }

  // Добавление имени колонки и значения в localstorage  {'phone': 230, ...}
  addToCache(key, objectWithWidthParameters) {
    if (Object.keys(objectWithWidthParameters)?.length == 0) {
      return
    }

    let oldCache = JSON.parse(localStorage.getItem(key))
    if (!oldCache) {
      localStorage.setItem(key, JSON.stringify(objectWithWidthParameters))
      return
    }
    let newCache = { ...oldCache, ...objectWithWidthParameters }
    localStorage.setItem(key, JSON.stringify(newCache))
    objectWithWidthParameters = {}
  }

  // Получение значения из вложенного объекта
  valueGetter(params) {
    var props = params.colDef.field.split('.')
    // Значения из объекта строки
    var value = params.data
    // Поиск заданного значения
    for (let i = 0; i < props.length; i++) {
      value = value[props[i]]
      if (!value) {
        return params.data[params.colDef.field]
      }
    }
    return value
  }
}
